import MaterialLabelWithThumb from './MaterialLabelWithThumb';
import InfoIcon from '@mui/icons-material/Info';
import {
  Card,
  CardContent,
  CardHeader,
  InputAdornment,
  Typography,
} from '@mui/material';
import HtmlTooltip from 'tooltip/HtmlTooltip';
import { Materials } from 'Types';

function MaterialPatternInputAdornment() {
  return (
    <InputAdornment position="end">
      <HtmlTooltip
        placement="right"
        title={
          <Card>
            <CardHeader title="Pattern Format"></CardHeader>
            <CardContent>
              <Typography>
                Patterns consist of one or more blocks that have a wood type and
                a size. For example, "1W 1M" would represent 1in of walnut
                followed by 1in of maple.
              </Typography>

              <br />

              <Typography>Valid wood types are...</Typography>

              {Materials.map((material) => (
                <MaterialLabelWithThumb key={material} material={material} />
              ))}
            </CardContent>
          </Card>
        }
      >
        <InfoIcon sx={{ color: 'text.primary', height: 24 }}></InfoIcon>
      </HtmlTooltip>
    </InputAdornment>
  );
}

export default MaterialPatternInputAdornment;
